export default function CCInActive({
    width = 26,
    height = 28,
    className,
    style,
    fill = '#959595',
    stroke = '#959595',
}) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 26 28"
            fill="none"
            className={className}
            style={style}
            aria-hidden="true"
        >
            <path
                d="M13 19.7563L9.05664 14.2251L12.8203 16.4468L13 16.5522L13.1797 16.4468L16.9424 14.2251L13 19.7563Z"
                fill={fill}
                stroke={stroke}
                strokeWidth="0.708311"
            />
            <path
                d="M8.28906 11.9131L13 4.14941L17.7119 11.9131L13 14.7451L8.28906 11.9131Z"
                stroke={stroke}
                strokeWidth="0.708311"
            />
            <path
                d="M21.9141 0.866211L25.0557 7.35449L21.0303 17.9453L13 26.7158L4.96875 17.9453L0.943359 7.35449L4.08594 0.866211H21.9141Z"
                stroke={stroke}
                strokeWidth="1.73333"
            />
        </svg>
    );
}
